// extracted by mini-css-extract-plugin
export default {"notificationContainer":"index-module__notificationContainer___Gq0Ff"};